"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioView = void 0;
const audio_player_1 = require("@shared-modules/components/audio-player");
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const AudioView = (props) => {
    const { metaUrlBase, metadata, onPlay } = props;
    const previewUrl = metaUrlBase + metadata.image;
    const audioUrl = metaUrlBase + metadata.audio;
    return react_1.default.createElement(audio_player_1.AudioPlayer, { src: audioUrl, preview: previewUrl, onPlay: onPlay });
};
exports.AudioView = AudioView;
